export const HOST = process.env.REACT_APP_API_URL ?? 'http://localhost:3001';

export const MAX_TASK_LENGTH = 250;
export const MAX_PROJECT_TITLE_LENGTH = 50;
export const MAX_CARD_TITLE_LENGTH = 50;
export const MAX_TASK_DESCRIPTION_LENGTH = 1000;

export const MAX_USER_NAME = 20;
export const MAX_USER_LASTNAME = 30;
export const MAX_USER_PASSWORD = 20;